import { areEnvironmentVariablesDefined } from './utils/envVars.js';
// import { isMobile } from './utils/isMobile.js';
import {  getFormData } from './emails/prepareEmail.js';
import { config } from './utils/config.js';
import { sendPreparedEmail } from './emails/wordpress-email.js';

const onSubmitForm = async (formId) => {
    if (!areEnvironmentVariablesDefined() ) return;
    let modalMessage = '';
    try {
        let formData = getFormData(formId)        

        await Promise.all([
            // sendEmailToCustomer(formData, formId),
            // sendEmailToTeam(formData, formId)
            await sendPreparedEmail(formData, 'team'),
            await sendPreparedEmail(formData, 'customer')
        ]);

        modalMessage = `Your response is successfully recorded. Thank you.`
    } catch(error) {
        console.error('Email sending failed:', error);
        modalMessage = `Your response couldn't be delivered because of some error in connection. Please try again later.`
    }
    return modalMessage
}

const onClickWhatsapp = () => {
    if (!areEnvironmentVariablesDefined() ) return
    let mobileNum = config.mobileNum
    // let isOnMobile = isMobile()
    let apilink = 'https://'
    // apilink += isOnMobile ? 'api' : 'web'
    apilink += 'api'
    apilink += '.whatsapp.com/send?phone=' + mobileNum // + '&text=' + encodeURI("")
    apilink = 'whatsapp://send?phone=' + mobileNum
    window.open(apilink, '_blank');
}

export { onSubmitForm, onClickWhatsapp }
